var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-form-group"},[_c('Form'+_vm.form[_vm.index].type,{tag:"component",attrs:{"form":_vm.form,"index":_vm.index}})],1),_c('div',{staticClass:"flix-form-group"},[_c('formWidth',{attrs:{"data":{label: 'Breite', value: _vm.form[_vm.index].columnName.toString(), values: _vm.getWidth},"callback":_vm.setWidth}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }